import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import initializeI18n from './i18n'; // Import your initialization function
import i18n from './i18n'; // Import your initialized i18n instance
import { I18nextProvider } from 'react-i18next';
import { HelmetProvider } from 'react-helmet-async';

const container = document.getElementById('root');

initializeI18n().then(() => {
  const app = (
    <HelmetProvider>
      <App />
    </HelmetProvider>
  );

  if (container && container.hasChildNodes()) {
    hydrateRoot(container, app);
  } else if (container) {
    createRoot(container).render(app);
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
